const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	return newImage;
};

const checkSwatches = () => {
	document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
		wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
			input.addEventListener("click", (event) => {
				const primaryImage = wrapper.querySelector(".media--first");
				const secondaryImage = wrapper.querySelector(".media--second");
				const handleProduct = wrapper.dataset.product;

				if (event.currentTarget.checked && primaryImage) {
					wrapper
						.querySelectorAll(".js-color-swatches-link")
						.forEach((item) =>
							item.setAttribute("href", event.currentTarget.dataset.variantLink)
						);
					const currentColor = event.currentTarget.value;

					jQuery.getJSON(
						window.Shopify.routes.root + `products/${handleProduct}.js`,
						function (product) {
							const variant = product.variants.filter(
								(item) =>
									item.featured_media != null &&
									item.options.includes(currentColor)
							)[0];
							if (variant) {
								const newPrimaryImage = createImageElement(
									variant["featured_media"],
									primaryImage.className,
									primaryImage.sizes,
									product.title
								);

								if (newPrimaryImage.src !== primaryImage.src) {
									let flag = false;
									if (secondaryImage) {
										const secondaryImagePathname = new URL(secondaryImage.src)
											.pathname;
										const newPrimaryImagePathname = new URL(newPrimaryImage.src)
											.pathname;

										if (secondaryImagePathname == newPrimaryImagePathname) {
											primaryImage.remove();
											secondaryImage.classList.remove("media--second");
											secondaryImage.classList.add("media--first");
											flag = true;
										}
									}
									if (flag == false) {
										primaryImage.animate(
											{ opacity: [1, 0] },
											{ duration: 200, easing: "ease-in", fill: "forwards" }
										).finished;
										setTimeout(function () {
											primaryImage.replaceWith(newPrimaryImage);
											newPrimaryImage.animate(
												{ opacity: [0, 1] },
												{ duration: 200, easing: "ease-in" }
											);
											if (secondaryImage) {
												secondaryImage.remove();
											}
										}, 200);
									}
								}
							}
						}
					);
				}
			});
		});
	});
};

function colorSwatches() {
	checkSwatches();

	document.addEventListener("shopify:section:load", function () {
		checkSwatches();
	});
}

// Mobile auto-swap functionality
function initMobileImageSwap() {
	// Only run on mobile devices (max-width: 989px to match Shopify's tablet breakpoint)
	const isMobile = () => window.innerWidth < 990;

	if (!isMobile()) return;

	const productCardMedias = document.querySelectorAll('.js-product-card-media[data-auto-swap-mobile="true"]');
	const swapIntervals = new Map();

	const swapImages = (mediaContainer) => {
		const primaryImage = mediaContainer.querySelector('.js-primary-image');
		const secondaryImage = mediaContainer.querySelector('.js-secondary-image');

		if (!primaryImage || !secondaryImage) return;

		// Toggle opacity
		const primaryOpacity = window.getComputedStyle(primaryImage).opacity;

		if (primaryOpacity === '1' || primaryOpacity === '') {
			primaryImage.style.opacity = '0';
			secondaryImage.style.opacity = '1';
		} else {
			primaryImage.style.opacity = '1';
			secondaryImage.style.opacity = '0';
		}
	};

	const startSwapping = (mediaContainer) => {
		// Only start if not already swapping
		if (swapIntervals.has(mediaContainer)) return;

		const intervalId = setInterval(() => {
			swapImages(mediaContainer);
		}, 2000);

		swapIntervals.set(mediaContainer, intervalId);
	};

	const stopSwapping = (mediaContainer) => {
		const intervalId = swapIntervals.get(mediaContainer);
		if (intervalId) {
			clearInterval(intervalId);
			swapIntervals.delete(mediaContainer);

			// Reset to primary image
			const primaryImage = mediaContainer.querySelector('.js-primary-image');
			const secondaryImage = mediaContainer.querySelector('.js-secondary-image');

			if (primaryImage) primaryImage.style.opacity = '1';
			if (secondaryImage) secondaryImage.style.opacity = '0';
		}
	};

	// Use Intersection Observer to detect when cards are in viewport
	const observerOptions = {
		root: null,
		rootMargin: '0px',
		threshold: 0.5 // 50% of the card must be visible
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				startSwapping(entry.target);
			} else {
				stopSwapping(entry.target);
			}
		});
	}, observerOptions);

	// Observe all product card media containers
	productCardMedias.forEach(media => {
		// Only observe cards that have both primary and secondary images
		const hasSecondaryImage = media.querySelector('.js-secondary-image');
		if (hasSecondaryImage) {
			observer.observe(media);
		}
	});

	// Cleanup on window resize (if switching to desktop)
	let resizeTimer;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			if (!isMobile()) {
				// Stop all swapping and cleanup
				swapIntervals.forEach((intervalId, mediaContainer) => {
					stopSwapping(mediaContainer);
				});
				observer.disconnect();
			}
		}, 250);
	});

	// Cleanup on Shopify section unload
	document.addEventListener('shopify:section:unload', () => {
		swapIntervals.forEach((intervalId, mediaContainer) => {
			stopSwapping(mediaContainer);
		});
		observer.disconnect();
	});
}

(function () {
	colorSwatches();

	// Initialize mobile image swap after DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initMobileImageSwap);
	} else {
		initMobileImageSwap();
	}

	// Re-initialize on Shopify section load
	document.addEventListener('shopify:section:load', initMobileImageSwap);
})();
